var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(!_vm.deleted)?_c('div',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.destroy()}}},[_c('i',{staticClass:"fas fa-trash"})]):_c('div',[_vm._v("\n    gelöscht\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }